var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('PageSummary',{attrs:{"headline":"A unique twist on fantasy sports"}},[_c('p',[_vm._v(" Enable "),_c('router-link',{attrs:{"to":{ name: 'pushInfo' }}},[_vm._v("push notifications")]),_vm._v(" to enhance your experience. ")],1)]),_c('AllLeagues')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }